<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <order-menu :menuType="3" />
        <div class="collection_con">
          <div class="collec_title"><i>我的收藏</i></div>
          <div class="side">
            <div class="collec_state">
              <div class="info_row">商品信息</div>
              <div class="ctrl_row">操作</div>
            </div>
            <ul class="collec_item" v-for="(item, index) in getcollList" :key="index">
              <li class="row1">
                <img :src="item.smallPhoto" alt="" srcset="" class="collec_img">
                <div class="item_title">
                  {{item.productName}}
                </div>
              </li>
              <li class="row2">
                <div @click="callHandle(item.productId)">取消收藏</div>
                <div @click="goDetailHandle(item.productId)">查看商品</div>
              </li>
            </ul>
          </div>
             <div class="collection_page">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :page-count="pageCount"
              @current-change="currentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { posts } from '../../utils/posts'
import crumb from '../../components/bread-crumb/Index.vue'
import orderMenu from '../../components/order_menu.vue'
import { ElMessage } from 'element-plus'
export default {
  name: '我的收藏',
  components: {
    crumb,
    orderMenu
  },
  setup () {
    const store = useStore()
    const router = useRouter()
    const userInfo = store.state.userInfo
    const getcollList = ref([])
    const page = ref(1) // 默认页数
    const pageSize = ref(10) // 默认每页数量
    const pageCount = ref(1) // 总页数
    const totalCount = ref(0)
    // 查看商品
    const goDetailHandle = (id) => {
      router.push({ path: '/product/detail', query: { pid: id } })
    }
    // 取消收藏
    const callHandle = (id) => {
      posts('collection/coll/' + userInfo.uid, { pid: id }).then(res => {
        ElMessage({
          showClose: true,
          message: '取消收藏成功',
          type: 'success'
        })
        getcollHandle()
      })
    }
    // 获取分页数量
    const currentChange = (e) => {
      page.value = e
      getcollHandle()
    }
    // 获取收藏列表
    const getcollHandle = () => {
      posts('collection/getcoll/' + userInfo.uid, { page: page.value, pageSize: pageSize.value }).then(res => {
        pageCount.value = res.pageCount
        getcollList.value = res.data
      })
    }
    onMounted(() => {
      getcollHandle()
    })
    return {
      goDetailHandle,
      callHandle,
      currentChange,
      page,
      pageSize,
      pageCount,
      totalCount,
      getcollList,
      userInfo
    }
  }
}
</script>
<style lang="scss">
.container {
  width: 1200px;
}
.lg {
  display: flex;
  justify-content: space-between;
  margin: 36px 0 50px 0;
  .collection_con {
    width: 880px;
    background: white;
    .collection_page{
      padding: 20px 30px;
      display: flex;
      justify-content: flex-end;
    }
    .side {
      margin: 30px 30px 0 30px;
      padding: 0 0 20px 0;
      border: 1px solid #eeeeee;
      height: 630px;
      .collec_item {
        padding: 20px 20px 0 20px;
        display: flex;
        justify-content: space-between;
        .row2 {
          flex: 1;
          padding: 0 0 0 12px;
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          div{
            cursor: pointer;
            color:#999999;
            font-size: 14px;
          }
        }
        .row1 {
          flex: 2;
          display: flex;
          align-items: center;
          padding: 0 12px 0 0;
          .item_title {
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            color: #3e3a39;
          }
          .collec_img {
            width: 80px;
            height: 80px;
            overflow: hidden;
            margin: 0 12px 0 0;
           }
        }
      }
      .collec_state {
        padding: 14px 20px;
        background: #f5f5f5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: #3e3a39;
        .info_row {
          flex: 2;
        }
        .ctrl_row {
          flex: 1;
          text-align: center;
        }
      }
    }
    .collec_title {
      height: 48px;
      padding: 12px 20px;
      font-size: 18px;
      font-weight: 600;
      color: #3e3a39;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      em {
        color: #fc4353;
      }
    }
  }
}
</style>
